// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n.bg[data-v-1df897a8]{\n  z-index:0\n}\nimg[data-v-1df897a8],video[data-v-1df897a8]{\n  width:100%;\n  height:100%;\n  -o-object-fit:cover;\n     object-fit:cover\n}\n\n/* purgecss end ignore */", ""]);
// Exports
module.exports = exports;
